import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Lenis from "lenis";
import Header from "./Header";
import Footer from "./Footer";
import ChatWidget from "./ChatWidget";
import { waLink, track } from "../lib/api";
import { MessageCircle } from "lucide-react";

export default function Layout() {
  const loc = useLocation();
  const lenisRef = React.useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    lenisRef.current = lenis;
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); lenisRef.current = null; };
  }, []);

  useEffect(() => {
    if (lenisRef.current) lenisRef.current.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, [loc.pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-ivory relative">
      <Header />
      <main className="flex-1"><Outlet /></main>
      <Footer />
      <a
        href={waLink()} target="_blank" rel="noreferrer"
        onClick={() => track("whatsapp_click", { path: loc.pathname })}
        className="fixed bottom-6 left-6 z-50 flex items-center gap-2 rounded-full bg-[#25D366] text-white px-5 py-3.5 shadow-lg shadow-black/20 hover:scale-105 transition-transform"
        data-testid="whatsapp-float"
      >
        <MessageCircle className="h-5 w-5" />
        <span className="text-sm font-semibold hidden sm:block">Chat on WhatsApp</span>
      </a>
      <ChatWidget />
    </div>
  );
}
